import { useSpotifySlots } from '../hooks/useSpotifySlots';
import { FaTrash, FaSync } from 'react-icons/fa';

export const SpotifySlotAdmin = () => {
  const { slot1, slot2, clearSlot } = useSpotifySlots();

  const handleClearSlot = async (slotNumber: 1 | 2) => {
    const confirm = window.confirm(`¿Seguro que quieres limpiar el Slot ${slotNumber}?`);
    if (confirm) {
      try {
        await clearSlot(slotNumber);
        alert(`Slot ${slotNumber} limpiado exitosamente`);
      } catch (error) {
        alert(`Error limpiando slot: ${error}`);
      }
    }
  };

  return (
    <div className="bg-white/50 rounded-xl shadow-lg p-6">
      <h3 className="text-2xl font-bold text-text-main mb-4">🎵 Administración de Spotify Slots</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Slot 1 */}
        <div className="bg-white/70 p-4 rounded-lg border-2 border-green-400/50">
          <div className="flex justify-between items-start mb-3">
            <h4 className="font-bold text-lg">Slot 1</h4>
            <span className={`px-2 py-1 rounded text-xs font-bold ${slot1.isEmpty ? 'bg-red-100 text-red-600' : 'bg-green-100 text-green-600'}`}>
              {slot1.isEmpty ? 'Vacío' : 'Conectado'}
            </span>
          </div>

          {!slot1.isEmpty ? (
            <div className="space-y-2">
              <p className="text-sm"><span className="font-semibold">Nombre:</span> {slot1.displayName}</p>
              <p className="text-sm"><span className="font-semibold">Spotify ID:</span> {slot1.spotifyId}</p>
              <p className="text-sm"><span className="font-semibold">Conectado por:</span> {slot1.connectedBy}</p>
              {slot1.connectedAt && (
                <p className="text-sm">
                  <span className="font-semibold">Fecha:</span>{' '}
                  {new Date(slot1.connectedAt.seconds * 1000).toLocaleDateString()}
                </p>
              )}

              <button
                onClick={() => handleClearSlot(1)}
                className="mt-3 w-full flex items-center justify-center gap-2 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
              >
                <FaTrash /> Limpiar Slot 1
              </button>
            </div>
          ) : (
            <div className="text-center py-4 text-gray-500">
              <p>Este slot está vacío</p>
              <p className="text-xs mt-2">Los usuarios pueden conectar su Spotify desde la página principal</p>
            </div>
          )}
        </div>

        {/* Slot 2 */}
        <div className="bg-white/70 p-4 rounded-lg border-2 border-purple-400/50">
          <div className="flex justify-between items-start mb-3">
            <h4 className="font-bold text-lg">Slot 2</h4>
            <span className={`px-2 py-1 rounded text-xs font-bold ${slot2.isEmpty ? 'bg-red-100 text-red-600' : 'bg-green-100 text-green-600'}`}>
              {slot2.isEmpty ? 'Vacío' : 'Conectado'}
            </span>
          </div>

          {!slot2.isEmpty ? (
            <div className="space-y-2">
              <p className="text-sm"><span className="font-semibold">Nombre:</span> {slot2.displayName}</p>
              <p className="text-sm"><span className="font-semibold">Spotify ID:</span> {slot2.spotifyId}</p>
              <p className="text-sm"><span className="font-semibold">Conectado por:</span> {slot2.connectedBy}</p>
              {slot2.connectedAt && (
                <p className="text-sm">
                  <span className="font-semibold">Fecha:</span>{' '}
                  {new Date(slot2.connectedAt.seconds * 1000).toLocaleDateString()}
                </p>
              )}

              <button
                onClick={() => handleClearSlot(2)}
                className="mt-3 w-full flex items-center justify-center gap-2 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
              >
                <FaTrash /> Limpiar Slot 2
              </button>
            </div>
          ) : (
            <div className="text-center py-4 text-gray-500">
              <p>Este slot está vacío</p>
              <p className="text-xs mt-2">Los usuarios pueden conectar su Spotify desde la página principal</p>
            </div>
          )}
        </div>
      </div>

      <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4">
        <p className="text-sm text-blue-800">
          <strong>Nota:</strong> Los slots se manejan desde la página principal (Landing Page).
          Aquí solo puedes ver el estado y limpiar slots si es necesario.
        </p>
      </div>
    </div>
  );
};
